function swissLuhn(value) {
  console.log(value);
  const moduleTable = [0, 9, 4, 6, 8, 2, 7, 1, 3, 5];
  let carry = 0;
  for (var i = 0; i < value.length; i++) {
    carry = moduleTable[(carry + parseInt(value.charAt(i))) % 10];
  }
  return (10 - carry) % 10;
}

function luhn(value) {
  const check = value
    .replace(/\D/, '')
    .split('')
    .map(x => parseInt(x, 10))
    .map((x, idx) => (idx % 2 ? x * 2 : x))
    .map(x => (x > 9 ? (x % 10) + 1 : x))
    .reduce((accum, x) => (accum += x));
  console.log(check);
  return check % 10 === 0;
}

export default function(value) {
  if (!value) return true;
  if (typeof value !== 'string') return false;
  const parts = value.split('-');
  return (
    parts[0].length === 2 && // 2
    (parts[1].length === 5 || parts[1].length === 6) && // 5 or 6
    parts[2].length === 1 // 1
  );
}
